import axios from '../base/axios';
import API_KEY from './key';

const GET_ROMANCE = 'flixfrenzy/redux/GET_ROMANCE';

// eslint-disable-next-line default-param-last
const romanceReducer = (state = [], action) => {
  switch (action.type) {
    case GET_ROMANCE:
      return action.payload;
    default:
      return state;
  }
};

export const getRomance = () => (dispatch) => {
  axios.get(`discover/movie?api_key=${API_KEY}&with_genres=10749`).then((res) => {
    dispatch({
      type: GET_ROMANCE,
      payload: res.data,
    });
  });
};

export default romanceReducer;
